/**
 * Announcement banner – horizontal scrolling ticker. Shown when visible and text is set from admin.
 */
import { useEffect, useState } from 'react';
import { subscribeAnnouncement } from '../../data/repositories/AppConfigRepository';
import styles from './AnnouncementBanner.module.css';

const BANNER_HEIGHT = 36;

export function AnnouncementBanner({ onVisibilityChange }) {
  const [announcement, setAnnouncement] = useState({ text: '', visible: false });

  useEffect(() => {
    const unsub = subscribeAnnouncement(setAnnouncement);
    return () => unsub();
  }, []);

  useEffect(() => {
    const visible = announcement.visible && announcement.text.trim().length > 0;
    onVisibilityChange?.(visible);
  }, [announcement.visible, announcement.text, onVisibilityChange]);

  const show = announcement.visible && announcement.text.trim().length > 0;
  if (!show) return null;

  return (
    <div className={styles.banner} style={{ height: BANNER_HEIGHT }} role="region" aria-live="polite">
      <div className={styles.track}>
        <span className={styles.text}>{announcement.text.trim()}</span>
        <span className={styles.text} aria-hidden>{announcement.text.trim()}</span>
      </div>
    </div>
  );
}

export const ANNOUNCEMENT_BANNER_HEIGHT = BANNER_HEIGHT;
